module.exports = __webpack_public_path__ + "img/feature_live.9a4afa6c.svg";